export const selectSyncState = state => state.billing.syncing;
export const selectVerifiedState = state => state.billing.isVerified;
export const selectHtmlState = state => state.billing.html;